import {
  LivekitClientTransport,
  MockLivekitTransport,
  type LivekitTransport,
  type LivekitTransportOptions,
} from "./livekitTransport";

export interface TransportAdapterFactoryOptions extends LivekitTransportOptions {
  readonly kind?: "mock" | "livekit";
}

export function createTransportAdapter(options: TransportAdapterFactoryOptions): LivekitTransport {
  if (options.kind === "livekit") {
    return new LivekitClientTransport(options);
  }
  return new MockLivekitTransport(options);
}
